import lodashClonedeep from 'lodash/cloneDeep';
import { PropTypes } from 'prop-types';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { injectIntl, useIntl } from 'react-intl';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AccionaButton from '../../../../../components/AccionaButton';
import Dropdown from '../../../../../components/RegionSelect/Dropdown';
import { formReducer } from '../../../../../components/RegionSelect/Logic';
import RegionSelect from '../../../../../components/RegionSelect/RegionSelect';
import { MainContext } from '../../../../../context/MainContext';
import { getFile } from '../../../../../services/api/files';
import {
  checkRules,
  formIsValidated,
  regionsAreVisibled,
} from '../../../../../utils/formRules';
import SuccessPage from '../../Utils/SuccessPage';
import DeliveryForm from './Delivery/form';
import LaboratoryForm from './Laboratory/form';
import TemplateTable from './TemplateTable';

const CreateTemplate = ({
  tableAttr,
  formsAttr,
  closeForm,
  initialData,
  model,
  customFinishButton,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { fileName } = useParams();
  const { setLoading, setError } = useContext(MainContext);

  const REGIONS = tableAttr.map((col, index) => {
    return {
      x: 0,
      y: 0,
      width: 8,
      height: 3,
      isVisible: false,
      data: col,
      index: index,
    };
  });
  const [selectedRegion, setSelectedRegion] = useState('');
  const [unLockedRegion, setUnLockedRegion] = useState('');

  const [moveAllRegions, updateMoveAllRegions] = useState(false);
  const [formState, dispatchFormState] = useReducer(
    formReducer,
    lodashClonedeep(formsAttr),
  );
  const [regions, setRegions] = useState(REGIONS);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formFinished, setFormFinished] = useState(null);
  const [elementsLoaded, setElementsLoaded] = useState(null);
  const path = useLocation().pathname.includes('updateTemplate');

  const onChange = (regs) => {
    setRegions(regs);
  };

  const onClickLock = (data) => {
    if (unLockedRegion === '') {
      setUnLockedRegion(data);
      setSelectedRegion(data);
    } else if (unLockedRegion === data) {
      setUnLockedRegion('');
      setSelectedRegion('');
    }
  };

  const updateRegion = (region) => {
    const newRegions = [
      ...regions.slice(0, region.index),
      region,
      ...regions.slice(region.index + 1),
    ];
    onChange(newRegions);
  };

  const changeRegionData = (indexSelection, option, indexOriginal) => {
    //Cambiamos los datos de una región
    const regionSelected = regions[indexSelection];
    const regionFirst = regions[indexOriginal];
    regionSelected.x = regionFirst.x;
    regionSelected.y = regionFirst.y;
    regionSelected.width = regionFirst.width;
    regionSelected.height = regionFirst.height;
    regionFirst.isVisible = false;

    updateRegion(regionFirst);
    updateRegion(regionSelected);
    setUnLockedRegion(option);
    setSelectedRegion(option);
  };

  const regionRenderer = (regionProps) => {
    //Mostramos las regiones, cada una con un select asociado y el botón para eliminarla
    if (regionProps.data === selectedRegion) {
      let style = {
        minWidth: '320px',
        bottom: '-4em',
        marginBottom: '0px',
        zIndex: '1',
        position: 'absolute',
      };
      if (regions[regionProps.index].x < 50) style.left = '0em';
      else style.right = '0em';

      return (
        <div className="form-row text-label input-gray" style={style}>
          <Dropdown
            onSelection={(indexSelection, option, indexOriginal) =>
              changeRegionData(indexSelection, option, indexOriginal)
            }
            prevSelection={regionProps.data}
            disabled
            options={tableAttr}
            index={regionProps.index}
          />
        </div>
      );
    }
  };

  const onBack = () => navigate(-1);

  const formSelector = () => {
    const RegionSelector = (
      <div className="row row-project">
        <div className="col-xs-12 col-sm-9 col-md-9">
          <div
            className="col-xs-12 col-sm-12 col-md-12"
            style={{ paddingRight: '7px' }}
          >
            <RegionSelect
              maxRegions={tableAttr.length}
              regions={regions}
              constraint
              onChange={onChange}
              moveAllRegions={moveAllRegions}
              style={{ border: '1px solid black' }}
              selectedRegion={selectedRegion}
              setSelectedRegion={setSelectedRegion}
              unLockedRegion={unLockedRegion}
              onClickLock={onClickLock}
              updateMoveAllRegions={updateMoveAllRegions}
              regionRenderer={path ? regionRenderer : null}
            >
              <img
                style={{ userSelect: 'none' }}
                alt="region-select-img"
                id="region-select-canvas"
                src={selectedFile}
              />
            </RegionSelect>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12">
            <div className="form-row row-bottom" style={{ marginTop: '10px' }}>
              <AccionaButton
                id="saveTemplateBtn"
                htmlType="submit"
                style={{ marginLeft: '0px' }}
                disabled={
                  !(formIsValidated(formState) && regionsAreVisibled(regions))
                }
                onClick={finishForm}
                msg={intl.formatMessage({ id: 'save' })}
                classIcon="icon fas fa-check"
              />
              <AccionaButton
                msg={intl.formatMessage({ id: 'back' })}
                onClick={onBack}
                classIcon="icon fas fa-chevron-left"
                style={{ float: 'right', marginRight: '-8px' }}
              />
            </div>
          </div>
        </div>
        <div
          className="col-xs-12 col-sm-3 col-md-3"
          style={{ paddingRight: '30px', paddingLeft: '8px' }}
        >
          <TemplateTable
            onClick={onClickTable}
            orderTable={tableAttr}
            regions={regions}
            selectedRegion={selectedRegion}
            unLockedRegion={unLockedRegion}
            onClickLock={onClickLock}
          />
        </div>
      </div>
    );
    const props = {
      formState: formState,
      updateForm: updateForm,
      moveAllRegions: moveAllRegions,
      updateMoveAllRegions: updateMoveAllRegions,
    };
    switch (model) {
      case 'delivery':
        return <DeliveryForm {...props}>{RegionSelector}</DeliveryForm>;
      case 'laboratory':
        return <LaboratoryForm {...props}>{RegionSelector}</LaboratoryForm>;
      default:
        return <></>;
    }
  };

  useEffect(() => {
    async function loadFile(name) {
      setLoading(true);
      try {
        const file = await getFile(name.replace('pdf', 'png'), model);
        setSelectedFile(URL.createObjectURL(file.data));
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    }
    loadFile(fileName);
  }, [fileName, setLoading, setError, model]);

  useEffect(() => {
    if (initialData) setElementsLoaded(initialData);
  }, [initialData]);

  useEffect(() => {
    const recreateRegions = (templateRegions) => {
      setRegions((prev) => {
        return [...prev].map((x, index) => {
          const templateRegion = templateRegions.find((r) => {
            return r.data === x.data;
          });
          templateRegion.index = index;
          templateRegion.isVisible = true;

          return templateRegion;
        });
      });
    };
    if (elementsLoaded) {
      recreateRegions(elementsLoaded.regions);
      const objkeys = Object.keys(elementsLoaded.form);
      objkeys.forEach((key) => {
        dispatchFormState({
          field: key,
          type: 'updateFormField',
          value: elementsLoaded.form[key],
          status: [],
        });
      });
    }
  }, [elementsLoaded]);

  const updateForm = (label, value) => {
    dispatchFormState({
      field: label,
      type: 'updateFormField',
      value: value,
      status: checkRules(value, formState[label].rules),
    });
  };

  const finishForm = async () => {
    try {
      setLoading(true);
      const closemsg = await closeForm(regions, formState, fileName);
      setLoading(false);
      setFormFinished(closemsg);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const onClickTable = (event, region) => {
    event.preventDefault();
    if (unLockedRegion === '') {
      //Gestionamos los clicks en un elemento de la tabla
      if (region.isVisible === false) {
        region.isVisible = true;
        region.x = 0;
        region.y = 0;
        region.width = 10;
        region.height = 4;
      }
      setUnLockedRegion(region.data);
    }
    if (event.target.className.includes('fa')) return;
    if (moveAllRegions) updateMoveAllRegions(false);
    setSelectedRegion(region.data);
    updateRegion(region);
  };

  if (formFinished) {
    return (
      <SuccessPage
        formatmsg={formFinished}
        customFinishButton={customFinishButton}
      />
    );
  }
  return formSelector();
};

CreateTemplate.defaultProps = {
  initialData: null,
  customFinishButton: undefined,
};

CreateTemplate.propTypes = {
  tableAttr: PropTypes.arrayOf(String).isRequired,
  formsAttr: PropTypes.object.isRequired,
  closeForm: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  initialData: PropTypes.object,
  customFinishButton: PropTypes.func,
};

export default injectIntl(CreateTemplate);
